import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { SummaryTab } from "@/components/regulatory/SummaryTab";
import { ValidationTab } from "@/components/regulatory/ValidationTab";
import { ReportBuilderTab } from "@/components/regulatory/ReportBuilderTab";
import { AuditLogTab } from "@/components/regulatory/AuditLogTab";

export default function RegulatoryReporting() {
  const [activeTab, setActiveTab] = useState("summary");

  return (
    <div className="flex-1 space-y-4 px-6 py-6">
      
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Regulatory Reporting</h1>
          <p className="text-muted-foreground">
            Manage jurisdiction-specific regulatory classifications and generate compliant reports
          </p>
        </div>
        <div className="flex gap-2">
          <Badge 
            variant="outline" 
            className="border-[#0033A0] text-[#0033A0] bg-[#0033A0]/5"
          >
            MAS Compliant
          </Badge>
        </div>
      </div>

      <Card className="p-6">
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6">
            <TabsTrigger value="summary">Summary</TabsTrigger>
            <TabsTrigger value="validation">Validation</TabsTrigger>
            <TabsTrigger value="report-builder">Report Builder</TabsTrigger>
            <TabsTrigger value="audit-log">Audit Log</TabsTrigger>
          </TabsList>
          
          <TabsContent value="summary">
            <SummaryTab />
          </TabsContent>
          
          <TabsContent value="validation">
            <ValidationTab />
          </TabsContent>
          
          <TabsContent value="report-builder">
            <ReportBuilderTab />
          </TabsContent>
          
          <TabsContent value="audit-log">
            <AuditLogTab />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
}
